// extracted by mini-css-extract-plugin
module.exports = {"root":"NotAvailable-module__root___3Jbmj","text":"NotAvailable-module__text___TjCMv"};